import React from 'react'
import { withFirebase } from '../Fb'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import TinyEditor from '../Editor/TinyEditor'

const emptyTier = () => ({ min: '', max: '', cost: '' })

class ProshopDeliverySettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      deliveryTiers: [],
      deliveryInfo: '',
      deliveryTerms: '',
      confirmationMessage: '',
      loading: true,
      saved: true,
    }
  }

  componentDidMount() {
    this.unsubscribe = this.props.firebase.getConfig('proshop').onSnapshot((doc) => {
      const data = doc.exists ? doc.data() : {}
      const deliveryTiers = Array.isArray(data.deliveryTiers)
        ? data.deliveryTiers.map((t) => ({
            min: t.min != null ? t.min : '',
            max: t.max != null ? t.max : '',
            cost: t.cost != null ? t.cost : '',
          }))
        : []
      this.setState({
        deliveryTiers,
        deliveryInfo: data.deliveryInfo || '',
        deliveryTerms: data.deliveryTerms || '',
        confirmationMessage: data.confirmationMessage || '',
        loading: false,
      })
    })
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  addTier = () => {
    this.setState({ deliveryTiers: [...this.state.deliveryTiers, emptyTier()], saved: false })
  }

  updateTier = (index, field, value) => {
    const deliveryTiers = this.state.deliveryTiers.map((tier, i) =>
      i === index ? { ...tier, [field]: value } : tier
    )
    this.setState({ deliveryTiers, saved: false })
  }

  removeTier = (index) => {
    this.setState({
      deliveryTiers: this.state.deliveryTiers.filter((_, i) => i !== index),
      saved: false,
    })
  }

  onSave = () => {
    const deliveryTiers = this.state.deliveryTiers
      .filter((t) => t.min !== '' || t.max !== '' || t.cost !== '')
      .map((t) => ({
        min: t.min === '' ? 0 : Number(t.min),
        max: t.max === '' ? null : Number(t.max),
        cost: t.cost === '' ? 0 : Number(t.cost),
      }))
    this.props.firebase
      .addConfig('proshop', {
        deliveryTiers,
        deliveryInfo: this.state.deliveryInfo || '',
        deliveryTerms: this.state.deliveryTerms || '',
        confirmationMessage: this.state.confirmationMessage || '',
      })
      .then(() => {
        this.setState({ saved: true })
      })
  }

  render() {
    if (this.state.loading) return null
    return (
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant='h5' sx={{ mb: 2 }}>
            Toimitus ja tilausvahvistus
          </Typography>

          <Typography variant='subtitle1' sx={{ mb: 1 }}>
            Toimituskulut tilauksen summan mukaan
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            Määritä portaat tilauksen loppusumman mukaan. Jätä yläraja tyhjäksi ylimmälle
            portaalle. Jos tilauksen tuotteella on oma toimituskulu, se korvaa porrastuksen
            (korkein voittaa).
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1, mb: 2 }}>
            {this.state.deliveryTiers.map((tier, index) => (
              <Box key={index} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <TextField
                  label='Alaraja (€)'
                  type='number'
                  size='small'
                  value={tier.min}
                  onChange={(e) => this.updateTier(index, 'min', e.target.value)}
                  inputProps={{ min: 0, step: 0.01 }}
                  sx={{ width: 130 }}
                />
                <TextField
                  label='Yläraja (€)'
                  type='number'
                  size='small'
                  value={tier.max}
                  onChange={(e) => this.updateTier(index, 'max', e.target.value)}
                  inputProps={{ min: 0, step: 0.01 }}
                  sx={{ width: 130 }}
                />
                <TextField
                  label='Toimituskulu (€)'
                  type='number'
                  size='small'
                  value={tier.cost}
                  onChange={(e) => this.updateTier(index, 'cost', e.target.value)}
                  inputProps={{ min: 0, step: 0.01 }}
                  sx={{ width: 150 }}
                />
                <IconButton aria-label='Poista' onClick={() => this.removeTier(index)}>
                  <DeleteOutlineIcon />
                </IconButton>
              </Box>
            ))}
            <Box>
              <Button variant='outlined' size='small' onClick={this.addTier}>
                Lisää porras
              </Button>
            </Box>
          </Box>

          <Typography variant='subtitle1' sx={{ mb: 1 }}>
            Toimitustiedot
          </Typography>
          <TinyEditor
            value={this.state.deliveryInfo}
            disableSave
            onChange={(html) => this.setState({ deliveryInfo: html, saved: false })}
          />

          <Typography variant='subtitle1' sx={{ mb: 1, mt: 2 }}>
            Toimitusehdot
          </Typography>
          <TinyEditor
            value={this.state.deliveryTerms}
            disableSave
            onChange={(html) => this.setState({ deliveryTerms: html, saved: false })}
          />

          <Typography variant='subtitle1' sx={{ mb: 1, mt: 2 }}>
            Tilausvahvistuksen viesti
          </Typography>
          <TinyEditor
            value={this.state.confirmationMessage}
            disableSave
            onChange={(html) => this.setState({ confirmationMessage: html, saved: false })}
          />

          <Box sx={{ mt: 2 }}>
            <Button variant='contained' disabled={this.state.saved} onClick={this.onSave}>
              Tallenna
            </Button>
          </Box>
        </CardContent>
      </Card>
    )
  }
}

export default withFirebase(ProshopDeliverySettings)
